<template>
  <n-config-provider :locale="ruRU" :date-locale="dateRuRU" :theme-overrides="themeOverrides">
    <div class="bg-gray-100 font-inter text-gray-600 antialiased">
      <component :is="layout">
        <router-view />
      </component>
    </div>
  </n-config-provider>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { useRoute } from "vue-router";
import { NConfigProvider, ruRU, dateRuRU, enUS, dateEnUS } from "naive-ui";
import { GlobalThemeOverrides } from "naive-ui";

import EmptyLayout from "@/modules/layouts/EmptyLayout.vue";
import MainLayout from "@/modules/layouts/MainLayout.vue";

const themeOverrides: GlobalThemeOverrides = {
  common: {
    primaryColor: "#6366F1",
    primaryColorHover: "#4F46E5",
  },
};

export default defineComponent({
  components: {
    EmptyLayout,
    MainLayout,
    NConfigProvider,
  },

  setup() {
    const route = useRoute();
    const layout = computed(() => {
      return (route.meta.layout || "empty") + "-layout";
    });

    return {
      themeOverrides,
      layout,
    };
  },
  data() {
    return {
      ruRU,
      dateRuRU,
      // enUS,
      // dateEnUS,
    };
  },
});
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.disabled-overlay {
  pointer-events: none;
  opacity: 0.5;
}

.deleted_notification {
  border: 2px solid red;
  border-radius: 5px;
  margin: 20px;
  font-size: 16px;
  text-align: center;
  padding: 10px;
}
</style>
